/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useEffect, useMemo, useState } from 'react';
import { useGetDirectorySettingsQuery } from 'store/api/version-api.slice';

const DirectorySettingsForm = ({ handleChange }) => {
	const [directorySettingsState, setDirectorySettingsState] = useState([]);

	const { data: directorySettingsResponse = {} } = useGetDirectorySettingsQuery();

	const directorySettings = useMemo(() => directorySettingsResponse.results || [], []);

	useEffect(() => {
		setDirectorySettingsState(directorySettings);
	}, [directorySettings]);

	const handleCheck = item => event => {
		const newFields = [{ ...directorySettingsState[0] }];

		newFields[0][item] = event.target.checked;

		setDirectorySettingsState(newFields);

		handleChange(newFields);
	};

	return (
		<Grid container spacing={2} sx={{ display: 'flex', padding: '16px' }}>
			<Grid item sm={12} xs={12}>
				<Paper sx={{ padding: '16px' }}>
					<Typography component={'span'} color="primary" variant="h6">
						MEMBERSHIP DIRECTORY SETTINGS
					</Typography>
					<List>
						{Object.entries(directorySettingsState[0] || {}).map(key => {
							if (key[0] === 'account') {
								return;
							}
							return (
								<Box key={key[0]}>
									<ListItem>
										<ListItemText>{key[0]}:</ListItemText>
										<ListItemSecondaryAction>
											<Checkbox
												edge="end"
												name={key[0]}
												onChange={handleCheck(key[0])}
												checked={key[1]}
											/>
										</ListItemSecondaryAction>
									</ListItem>
									<Divider component="li" />
								</Box>
							);
						})}
					</List>
					<Grid container spacing={2}></Grid>
				</Paper>
			</Grid>
			<Grid item sm={6} xs={12} sx={{ display: 'flex' }}></Grid>
		</Grid>
	);
};

export default DirectorySettingsForm;
